import GET_RENEWABLE_SUBSCRIPTIONS from "./get-renewable-subscriptions.graphql";
import { isIsul, isIsulGroup } from "../../domain/plan";
import { publicConfig } from "../../config";
import { isAllowRenewLegacySubscription } from "../../domain/subscription";

const toRenewableSubscription = ({
	id,
	name,
	expirationDate,
	isTrial,
	plan,
	isAutoBillingEnabled,
}) => ({
	id: +id,
	name,
	expirationDate,
	isTrial,
	planCode: plan.planCode,
	isAutoBillingEnabled,
});

const isIsulSubscription = ({ planCode }) => isIsul(planCode);
const isNotIsulSubscription = ({ planCode }) => !isIsul(planCode);
const isNotTrial = ({ isTrial }) => !isTrial;

const renewableSubscriptionsProvider = ({ gqlClient, storageService }) => () =>
	gqlClient(GET_RENEWABLE_SUBSCRIPTIONS)
		.then(result => result.getRenewableSubscriptions.map(toRenewableSubscription))
		.then(subscriptions => {
			const { planCode } = storageService.priceItem.read();
			if (isIsul(planCode)) {
				return publicConfig.IS_ISUL_GROUP_ENABLED
					? subscriptions.filter(isIsulSubscription)
					: subscriptions.filter(item => isIsul(item.planCode) && !isIsulGroup(item.planCode));
			}

			return subscriptions
				.filter(isNotIsulSubscription)
				.filter(isNotTrial) // not suggest upgrade legacy trial subscription
				.filter(isAllowRenewLegacySubscription);
		});

export default renewableSubscriptionsProvider;
